import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "supplies_box"
};
var _hoisted_2 = {
  class: "search_header",
  style: {
    "width": "400px",
    "margin-bottom": "10px"
  }
};
var _hoisted_3 = {
  class: "search_contain"
};
var _hoisted_4 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_5 = {
  class: "pagination_"
};
var _hoisted_6 = {
  class: "dialog-footer"
};
import { reactive, ref, watch, watchEffect, onMounted } from "vue";
import { purchase_bd_material } from "@/api/apis";
import { deepCopy } from "@/TUIKit/components/TUIChat/utils/utils";
export default {
  __name: 'purchaseDailog',
  props: ["isShow", "supplies", "title"],
  emits: ["closeDialog", "handleChoose"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var dialogVisible = ref(false);
    var props = __props;
    var emit = __emit;
    var search = () => {
      get_supplies_list();
    };
    /**
     * 选择物料明细
     */

    var multipleTableRef = ref(null);
    var wl_fy = ref({
      page: 1,
      limit: 15,
      total: 0
    });
    var supplies_list = ref([]); // 物料信息列表
    var key_word = ref("");
    var get_row = row => {
      return row.id;
    };
    var quotation_checked_ids = ref([]);

    /**
     *
     */
    var get_supplies_list = () => {
      purchase_bd_material({
        limit: wl_fy.value.limit,
        page: wl_fy.value.page,
        key_word: key_word.value
      }).then(res => {
        if (res.code == 200) {
          wl_fy.value.total = res.data.total;
          supplies_list.value = res.data.list || [];
          toggleCheck();
        }
      });
    };
    var toggleCheck = () => {
      var rows = [];
      supplies_list.value.map((item, index) => {
        if (quotation_checked_ids.value.findIndex(id => item.id == id) > -1) {
          rows.push(item);
          supplies_checked_list.value.push(item);
        }
      });
      toggleSelection(rows);
    };
    var handle_close = () => {
      dialogVisible.value = false;
      emit("closeDialog");
    };
    var handle_checked = () => {
      dialogVisible.value = false;
      emit("handleChoose", supplies_checked_list.value);
    };
    /**
     * 物料信息翻页
     */
    var handleCurrentChange = () => {
      get_supplies_list();
    };
    var supplies_checked_list = ref([]);
    var toggleSelection = rows => {
      if (rows) {
        rows.forEach(row => {
          multipleTableRef.value.toggleRowSelection(row);
        });
      } else {
        multipleTableRef.value.clearSelection();
      }
    };
    var handleSelectionChange = data => {
      supplies_checked_list.value = data;
    };
    var handleRowSelection = () => {};
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    onMounted(() => {});
    watch(() => {
      return dialogVisible.value;
    }, () => {
      wl_fy.value.page = 1;
      if (!dialogVisible.value) {
        emit("closeDialog");
      } else {
        if (props.supplies.details) {
          quotation_checked_ids.value = Array.from(props.supplies.details, _ref2 => {
            var {
              id
            } = _ref2;
            return id;
          });
        }
        wl_fy.value.page = 1;
        get_supplies_list();
      }
    });
    watch(() => {
      return props.supplies;
    }, () => {
      var _props$supplies;
      if ((_props$supplies = props.supplies) !== null && _props$supplies !== void 0 && _props$supplies.length) {
        quotation_checked_ids.value = props.supplies.map(item => item.id);
      }
      console.log("props.supplies", props.supplies, props.supplies.map(item => item.bd_material_id), quotation_checked_ids.value);
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_table = _resolveComponent("el-table");
      var _component_el_pagination = _resolveComponent("el-pagination");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "destroy-on-close": true,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        title: '请选择产品明细',
        style: {
          "width": "60%"
        },
        onClose: handle_close
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: handle_close
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_checked
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => key_word.value = $event),
          placeholder: "请输入型号/物料名称查询"
        }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("查询")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
          data: supplies_list.value,
          style: {
            "height": "100%"
          },
          "row-key": row => row.id,
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelectionChange: handleSelectionChange,
          onToggleRowSelection: handleRowSelection
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            "reserve-selection": true,
            type: "selection"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "model",
            label: "型号",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "code",
            label: "物料编码",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.code), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "basic_unit",
            label: "单位"
          })]),
          _: 1
        }, 8, ["data", "row-key"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};